const LOQATE_KEY = "HM57-FF85-WJ43-HG26";
export const LOQATE_ADDRESS_INTERACTIVE_URL = `https://api.addressy.com/Capture/Interactive/Find/v1.10/json3ex.ws?Key=${LOQATE_KEY}`;
export const LOQATE_ADDRESS_RETRIEVE_URL = `https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws?Key=${LOQATE_KEY}`;
